import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Card, CardContent } from "@/components/ui/card";
import { HelpCircle } from "lucide-react";

const FAQSection = () => {
  const faqs = [
    {
      question: "Combien de temps à l'avance dois-je commander ?",
      answer: "Nous recommandons de passer commande au moins 7 jours à l'avance pour garantir la disponibilité. Pour les gâteaux de mariage ou les créations très élaborées, prévoyez 2-3 semaines."
    },
    {
      question: "Quelles sont vos saveurs disponibles ?",
      answer: "Nous proposons de nombreuses saveurs : Vanille-Fraise, Chocolat, Mangue-Passion, Vanille-Coco, Spéculos-Caramel, Framboise, Noisette-Praliné, Kinder Bueno, Oreo, et bien d'autres. N'hésitez pas à nous faire part de vos préférences !"
    },
    {
      question: "Livrez-vous à domicile ?",
      answer: "Oui, nous proposons la livraison sur Lyon et Villeurbanne. Les frais de livraison varient selon la distance. Vous pouvez aussi venir récupérer votre commande directement à notre atelier."
    },
    {
      question: "Pouvez-vous faire des gâteaux sans allergènes ?",
      answer: "Nous pouvons adapter nos recettes pour certaines allergies (sans gluten, sans lactose, etc.). Merci de nous préciser vos contraintes alimentaires lors de la commande pour que nous puissions vous proposer des alternatives."
    },
    {
      question: "Comment se passe le paiement ?",
      answer: "Un acompte de 30% est demandé à la commande pour la réserver. Le solde est à régler lors de la livraison ou du retrait. Nous acceptons les paiements par carte, espèces ou virement."
    },
    {
      question: "Puis-je voir le gâteau avant la livraison ?",
      answer: "Bien sûr ! Nous envoyons toujours une photo de votre gâteau terminé avant la livraison ou le retrait. Si quelque chose ne vous convient pas, nous pouvons faire des ajustements."
    },
    {
      question: "Que se passe-t-il en cas d'annulation ?",
      answer: "Les annulations sont possibles jusqu'à 48h avant la date prévue. L'acompte sera remboursé à 50%. En cas d'annulation le jour même, l'acompte ne pourra pas être remboursé."
    },
    {
      question: "Faites-vous des gâteaux pour les entreprises ?",
      answer: "Absolument ! Nous réalisons des gâteaux pour tous types d'événements d'entreprise : inaugurations, anniversaires d'entreprise, pots de départ, etc. Contactez-nous pour un devis personnalisé."
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-pink-50/30">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 flex items-center justify-center">
            <HelpCircle className="w-12 h-12 mr-4 text-primary" />
            Questions fréquentes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Retrouvez ici les réponses aux questions les plus courantes. 
            Si vous ne trouvez pas ce que vous cherchez, n'hésitez pas à nous contacter !
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Card className="shadow-elegant border-pink-100">
            <CardContent className="p-6">
              <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, index) => (
                  <AccordionItem key={index} value={`item-${index}`} className="border-pink-100">
                    <AccordionTrigger className="text-left hover:text-primary transition-smooth">
                      <span className="font-medium">{faq.question}</span>
                    </AccordionTrigger>
                    <AccordionContent className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </CardContent>
          </Card>
        </div>

        {/* Contact CTA */}
        <div className="text-center mt-12">
          <div className="bg-gradient-to-r from-pink-50 to-yellow-50 rounded-xl p-8 border border-pink-100 max-w-2xl mx-auto">
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              Une autre question ?
            </h3>
            <p className="text-gray-600 mb-6">
              Notre équipe est là pour vous aider ! Contactez-nous par WhatsApp, 
              email ou via notre formulaire de contact.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => window.open("https://wa.me/33753797698", "_blank")}
                className="inline-flex items-center justify-center px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary/90 transition-smooth font-medium"
              >
                💬 WhatsApp direct
              </button>
              <button
                onClick={() => {
                  const element = document.querySelector("#contact");
                  if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                  }
                }}
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-primary text-primary rounded-lg hover:bg-primary hover:text-white transition-smooth font-medium"
              >
                📧 Formulaire de contact
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;